import React from "react";
import Region1 from "./Region1";
import Region2 from "./Region2";
import FilterContext from "../../routes/FilterContext";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class RegionContainer extends React.Component {
  static contextType = FilterContext;
  state = {
    filters: "{}",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.setState({ filters: filters });
  }

  componentDidUpdate() {
    if (this.state.filters !== JSON.stringify(this.props.filters)) {
      this.setState({ filters: JSON.stringify(this.props.filters) });
    }
  }

  renderAsset() {
    var filters = JSON.parse(this.state.filters);
    let isMarket = Object.keys(filters).includes("markets");
    let isMacromarkets = Object.keys(filters).includes("macromarkets");
    let isMicromarkets = Object.keys(filters).includes("micromarkets");

    if (this.state.filters == "{}") {
      return <Region1 />;
    } else if (
      isMarket ||
      isMacromarkets ||
      isMicromarkets
      // (filters.markets === undefined &&
      //   filters.macromarkets === undefined &&
      //   filters.micromarkets === undefined &&
      //   filters.markets.length === 0 &&
      //   filters.macromarkets.length === 0 &&
      //   filters.micromarkets.length === 0)
    ) {
      return <Region2 />;
    } else if (
      !isMarket &&
      !isMacromarkets &&
      isMicromarkets &&
      filters.macromarkets === undefined &&
      filters.micromarkets === undefined &&
      filters.markets.length === 0 &&
      filters.macromarkets.length === 0 &&
      filters.micromarkets.length === 0
    ) {
      return <Region1 />;
    } else {
      return <Region1 />;
    }
    // if (
    //   this.state.filters == "{}" ||
    //   (Object.keys(filters)[0] !== "markets" &&
    //     Object.keys(filters)[0] !== "macromarkets" &&
    //     Object.keys(filters)[0] !== "micromarkets") ||
    //   (filters.markets === undefined &&
    //     filters.macromarkets === undefined &&
    //     filters.micromarkets === undefined &&
    //     filters.markets.length === 0 &&
    //     filters.macromarkets.length === 0 &&
    //     filters.micromarkets.length === 0)
    // ) {
    //   return <Region2 />;
    // } else {
    //   return <Region1 />;
    // }
  }

  render() {
    if (this.state.filters !== undefined) {
      return this.renderAsset();
    } else {
      return <>Loading</>;
    }
  }
}

export default connect(mapStateToProps)(RegionContainer);
